@if (anchor) {
  <a [id]="anchor"></a>
}

<kb-card>
  <div slot="content">
    <section class="text">
      <h3 kb-heading [appEditorId]="editorIds?.headline">
        {{attributes.headline}}
      </h3>
      <kb-html [html]="attributes.content" [appEditorId]="editorIds?.content"></kb-html>
    </section>
    <section class="link-list">
      <h3 kb-heading [appEditorId]="editorIds?.linkListHeadline">
        {{attributes.linkListHeadline}}
      </h3>
      <ul kb-list [appEditorId]="editorIds?.linkList">
        @for (link of attributes.linkList; track link) {
          <li [appEditorId]="link.editorId">
            <a kb-link
              [kbRouterOrExternalLink]="link.attributes.url"
              [appTrackClick]="link.attributes.url"
            >
              {{link.attributes.label}}
            </a>
          </li>
        }
      </ul>
    </section>
  </div>
</kb-card>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
